import React, { useEffect, useState } from 'react';
import { obtenerConfiguracion } from '../../services/configTiendaApi';
import { getCategorias } from '../../services/categoriasServicio';
import { getProductosCatalogo } from '../../services/productosApi';

const CheckIcon = ({ hecho }) => (
    <div style={{
        width: '28px', height: '28px', borderRadius: '50%', flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: hecho ? '#22c55e' : '#e5e7eb',
        color: hecho ? '#fff' : '#9ca3af',
        fontWeight: 800, fontSize: '0.85rem'
    }}>
        {hecho ? '✓' : ''}
    </div>
);

function InicioMenuQR() {
    const [loading, setLoading] = useState(true);
    const [tienda, setTienda] = useState({ nombre: '', urlLogo: '', urlSlug: '' });
    const [numCategorias, setNumCategorias] = useState(0);
    const [numProductos, setNumProductos] = useState(0);

    useEffect(() => {
        const cargar = async () => {
            try {
                const [cfg, categorias, catalogo] = await Promise.all([
                    obtenerConfiguracion().catch(() => null),
                    getCategorias().catch(() => []),
                    getProductosCatalogo().catch(() => ({ productos: [] })),
                ]);
                if (cfg) {
                    setTienda({
                        nombre: cfg.nombre || '',
                        urlLogo: cfg.url_logo || cfg.urlLogo || '',
                        urlSlug: cfg.url_slug || cfg.urlSlug || '',
                    });
                }
                setNumCategorias((categorias || []).length);
                setNumProductos(((catalogo && catalogo.productos) || []).length);
            } finally {
                setLoading(false);
            }
        };
        cargar();
    }, []);

    const pasos = [
        { id: 'logo', label: 'Sube el logo de tu negocio', hecho: !!tienda.urlLogo, href: '/configuracion/tienda/' },
        { id: 'categorias', label: 'Crea tus categorías', hecho: numCategorias > 0, href: '/categorias/' },
        { id: 'productos', label: 'Agrega tus productos', hecho: numProductos > 0, href: '/productos/home/' },
        { id: 'qr', label: 'Comparte tu código QR con tus clientes', hecho: numCategorias > 0 && numProductos > 0, href: '/configuracion/tienda/' },
    ];

    const completados = pasos.filter(p => p.hecho).length;
    const listo = completados === pasos.length;
    const urlQr = tienda.urlSlug ? `${window.location.origin}/qr/${tienda.urlSlug}` : '';

    if (loading) {
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    return (
        <div className="min-vh-100 bg-light py-4">
            <div className="container" style={{ maxWidth: '720px' }}>
                <div className="text-center mb-4">
                    <h1 className="h3 font-weight-bold text-dark mb-1">
                        {listo ? '¡Tu catálogo está listo! 🎉' : `Hola${tienda.nombre ? ', ' + tienda.nombre : ''} 👋`}
                    </h1>
                    <p className="text-muted mb-0">
                        {listo
                            ? 'Ya puedes compartir tu QR y recibir pedidos.'
                            : 'Sigue estos pasos para dejar tu catálogo digital funcionando.'}
                    </p>
                </div>

                <div className="card shadow-sm border-0 rounded-lg p-4 mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="font-weight-bold text-dark">Progreso de tu catálogo</span>
                        <span className="badge badge-pill" style={{
                            background: listo ? '#dcfce7' : '#eef0ff',
                            color: listo ? '#16a34a' : '#667eea',
                            fontWeight: 700, padding: '6px 12px'
                        }}>{completados}/{pasos.length}</span>
                    </div>
                    <div className="progress mb-4" style={{ height: '8px', borderRadius: '8px' }}>
                        <div className="progress-bar bg-success" style={{ width: `${(completados / pasos.length) * 100}%`, borderRadius: '8px' }}></div>
                    </div>

                    {pasos.map((paso) => (
                        <a key={paso.id} href={paso.href} className="text-decoration-none">
                            <div className="d-flex align-items-center py-2" style={{ borderBottom: '1px solid #f3f4f6' }}>
                                <CheckIcon hecho={paso.hecho} />
                                <span className="ml-3" style={{ color: paso.hecho ? '#9ca3af' : '#1a1a2e', textDecoration: paso.hecho ? 'line-through' : 'none', fontWeight: 500 }}>
                                    {paso.label}
                                </span>
                                {!paso.hecho && (
                                    <span className="ml-auto text-primary" style={{ fontSize: '0.85rem', fontWeight: 600 }}>Ir →</span>
                                )}
                            </div>
                        </a>
                    ))}
                </div>

                {urlQr && (
                    <div className="card shadow-sm border-0 rounded-lg p-4 text-center">
                        <p className="text-muted mb-2" style={{ fontSize: '0.9rem' }}>Este es el enlace de tu catálogo:</p>
                        <a href={urlQr} target="_blank" rel="noreferrer" className="font-weight-bold" style={{ wordBreak: 'break-all' }}>
                            {urlQr}
                        </a>
                        <div className="mt-3">
                            <a href="/configuracion/tienda/" className="btn btn-dark">
                                Ver código QR y personalizar
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default InicioMenuQR;
